import { compose } from 'recompose'


import FeatureDisabledDueToInactiveAccountOrHold from '../../../common-components/FeatureDisabledDueToInactiveAccountOrHold'
import OrerAndEditShared from './containers'


export default compose(
  FeatureDisabledDueToInactiveAccountOrHold,
)(OrerAndEditShared)
